import {get_token,get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import MenuSideBar from '@/components/MenuSidebar/MenuSidebar.vue'
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue";
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';

import { client_domain } from "@/main.js";
import { is_organization_admin_role } from "@/utils/organization_profile";
import { view_profile as view_profile_helper } from "@/views/home/home_helper.js";


export default {
  components: {
    HomeNavBar,
    MenuSideBar,
    StickyNav,
    InactivityModal
  },
  inject: ['client_features'],
  data() {
    return ({
      token_exists:false,
      businessSearch: '',
      selectedNameFilter: '',
      selectedLocationFilter: '',
      selectedRatingFilter: '',
      business_profiles:[],
      profile_domain:false,
      cbo_domain:false,
      user_details: {
        "user_role": '',
      },
      loading: true,
      rating: null,
      totalRatings: 0,
      allRatings: [],
    })
  },
  computed: {
    can_create_business_profile() {
      return this.is_enabled_feature(this.client_features?.show_business_profile)
        && !is_organization_admin_role(this.user_details);
    },
    filteredBusinesses() {
      const searchTerm = this.businessSearch || '';
      const filtered = this.business_profiles.filter(b =>
        this.matchesBusinessSearch(b, searchTerm) &&
        (!this.selectedNameFilter || b.company_name === this.selectedNameFilter)
      );

      return filtered.sort((a, b) => {
        const nameA = a.company_name?.toLowerCase() || '';
        const nameB = b.company_name?.toLowerCase() || '';
        return nameA.localeCompare(nameB);
      });
    }
  },
  mounted() {

    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.fetchCompanyProfile();
    if(client_domain.includes('tdm') || client_domain.includes('chamber')){
      this.profile_domain=true
    }
    if(client_domain.includes('cbo')){
      this.cbo_domain=true}
  },

  methods: {
   is_enabled_feature(value) {
    return value === true || value === 'true' || value === 1 || value === '1';
   },
   get_rating() {
  this.isLoading = true;

  this.business_profiles.forEach(business => {
    const profileId = business.base_profile?.id;
    if (!profileId) return;

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/retrieve_profile_rating/`,
      type: 'POST',
      headers: {
        Authorization: `Token ${get_token()}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({ profile_id: profileId }),
      success: (response) => {
        if (response.status === 'success') {
          // Store rating info in the business object
          business.rating = Math.round(response.data.average_rating * 2) / 2; // round to nearest 0.5
          business.totalRatings = response.data.total_count;
          business.allRatings = response.data.ratings;
        }
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  });
},
    getToken() {
      return get_token();
    },
    matchesBusinessSearch(business, searchTerm) {
    if (!searchTerm) return true;

    const term = searchTerm.toLowerCase();

    const companyName = business.company_name?.toLowerCase() || '';
    const creatorName = `${business.base_profile?.creater?.first_name || ''} ${business.base_profile?.creater?.last_name || ''}`.toLowerCase();
    const companyLocation = business.location?.toLowerCase() || '';
    const companyEmail = business.email?.toLowerCase() || '';

    return (
      companyName.includes(term) ||
      creatorName.includes(term) ||
      companyLocation.includes(term) ||
      companyEmail.includes(term)
    );
  },
    fetchCompanyProfile() {
      this.loading = true;
        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_all_company_profile/`,
            type: "GET",
            headers: {
                Authorization: `Token ${get_token()}`,
                "Content-Type": "application/json",
            },
            success: (response) => {
                if (response.status === "success") {
                 this.business_profiles=response.data

                }
                this.loading = false;
            },
            error: (xhr, status, error) => {
                console.error("Error fetching company profile:", error);
                this.loading = false;
            },
            complete: () => {
              this.get_rating();
              this.loading = false;
            }

        });
      },
      view_profile(profile){
        view_profile_helper(this.$router, profile);
      }

    },
  

};
